import {
  MANUAL_WORK_ALL,
  MANUAL_WORK_POST,
  MANUAL_WORK_DEL,
  MANUAL_WORK_LOADING,
  MANUAL_WORK_ERROR,
} from '../types';
import api from '../../../utils/functions/api';

const BASE = `${process.env.REACT_APP_API_URL}/manual-work-entry`;

export const manualWorkAll = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: MANUAL_WORK_LOADING });
    const { data } = await api.get(BASE, { params });
    dispatch({ type: MANUAL_WORK_ALL, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: MANUAL_WORK_ERROR });
  }
};

export const manualWorkUpsert = (payload) => async (dispatch) => {
  try {
    const { data } = await api.post(BASE, payload);
    dispatch({ type: MANUAL_WORK_POST, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: MANUAL_WORK_ERROR });
    throw error;
  }
};

export const manualWorkDelete = (id) => async (dispatch) => {
  try {
    await api.delete(`${BASE}/${id}`);
    dispatch({ type: MANUAL_WORK_DEL, payload: id });
  } catch (error) {
    dispatch({ type: MANUAL_WORK_ERROR });
    throw error;
  }
};
